const URLTools = {
  install (Vue) {
    // Gets the value of a requested URL parameter
    Vue.prototype.$getParam = (param) => {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      return urlParams.get(param)
    }

    // Returns the correct domain name, for each of the following:
    // - production
    // - staging
    // - local dev machine
    // - webpack dev server
    Vue.prototype.$getEnvDomain = (platform) => {
      if (!platform || typeof platform !== 'string') {
        throw new Error('Required parameter \'platform\' is missing, or not a string.')
      } else {
        let domain = window.location.hostname

        if (process.env.NODE_ENV === 'development') {
          domain = `${platform.toLowerCase()}dev.${platform.toLowerCase()}.com`
        }

        return domain
      }
    }
  }
}

export default URLTools

// Automatic installation, if not using Vue CLI
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(URLTools)
}